import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setChat_Id,
  setExternalContactNumber,
  setExternalName,
  setExternalNo,
  setIsExternalValidation,
  setNewExternalConversation,
  setOpenExternalModal,
  setSelectedContactName,
} from "../../../../../services/store/slice/ChatSlice";
import {
  addExternalChat,
  sentExternalChatMessages,
} from "../../../../../services/api/apiManager";
import {
  Box,
  Button,
  Modal,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";
import { useLocation, useNavigate } from "react-router-dom";

const AddExternalChatModal = () => {
  const [externalMessage, setExternalMessage] = useState("");
  const { openExternalModal, externalNo, externalContactId } = useSelector(
    (state) => state.chat
  );
  const user_id = localStorage.getItem("user_id");
  const emptyAndClose = () => {
    dispatch(setOpenExternalModal(false));
    dispatch(setExternalNo(""));
    setExternalMessage("");
  };
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  // region add external chat
  const addNewExternalChat = async (externalNo) => {
    const number = externalNo.trim().replace(/^\+/, "");
    try {
      const res = await addExternalChat(`%2B${number}`);
      if (res.status === 200) {
        handleSendMessage({
          to: res.data?.result?.conversationName,
          message: externalMessage,
          chatId: parseInt(res.data?.result?.conversationId),
          senderId: parseInt(user_id),
        });
        dispatch(
          setNewExternalConversation({
            conversationName: res.data?.result?.conversationName,
            conversationId: parseInt(res.data?.result?.conversationId),
            userContactId: externalContactId,
          })
        );
        dispatch(setOpenExternalModal(false));
        enqueueSnackbar("Added External Chat", {
          variant: "success",
        });
      }
    } catch (error) {
      console.warn("Error fetching chats", error);
    }
  };

  // region send Message to external chat
  const handleSendMessage = async (externalNo) => {
    try {
      const res = await sentExternalChatMessages(
        externalNo,
        `temp-${Date.now()}`
      );
      if (res.status === 200) {
        dispatch(
          setExternalName(
            res?.data?.getmessge?.contact_Name != null &&
              res?.data?.getmessge?.contact_Name != undefined
              ? res?.data?.getmessge?.contact_Name
              : ""
          )
        );
        localStorage.setItem(
          "externalName",
          res?.data?.getmessge?.contact_Name != null &&
            res?.data?.getmessge?.contact_Name != undefined
            ? res?.data?.getmessge?.contact_Name
            : ""
        );
        dispatch(
          setExternalContactNumber(
            res?.data?.getmessge?.senderNo
              ? res?.data?.getmessge?.senderNo
              : null
          )
        );
        localStorage.setItem(
          "externalContactNumber",
          res?.data?.getmessge?.senderNo
        );

        localStorage.setItem("isExternal", true);
        localStorage.setItem(
          "selectedContactName",
          res?.data?.getmessge?.senderNo
        );
        dispatch(setChat_Id(res?.data?.getmessge?.conversationId));
        localStorage.setItem("chatId", res?.data?.getmessge?.conversationId);
        dispatch(setSelectedContactName(res?.data?.getmessge?.senderNo));
        dispatch(setIsExternalValidation(true));
        if (location.pathname !== "/chats") {
          navigate("/chats");
        }
        emptyAndClose();
      } else {
        emptyAndClose();
      }
    } catch (error) {
      console.warn("Error fetching chats", error);
      emptyAndClose();
    }
  };

  return (
    <div>
      <Modal open={openExternalModal}>
        <Box sx={modalStyle}>
          <Typography
            variant="h6"
            color={"#085F99"}
            fontWeight={"bold"}
            fontSize={"18px"}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            Start External Chat
          </Typography>
          <Typography
            id="modal-modal-description"
            sx={{
              m: "5px 0",
              fontSize: "14px",
              color: "#004E7C",
            }}
          >
            Type your message
          </Typography>
          <TextField
            placeholder="Write something"
            variant="outlined"
            fullWidth
            multiline
            rows={2}
            value={externalMessage}
            onChange={(e) => setExternalMessage(e.target.value)}
          />

          <Stack direction="row" spacing={2} justifyContent="flex-end" mt={1.5}>
            <Button
              variant="outlined"
              onClick={() => {
                dispatch(setOpenExternalModal(false));
                setExternalMessage("");
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={() => addNewExternalChat(externalNo)}
              disabled={!externalMessage.trim()}
            >
              Send
            </Button>
          </Stack>
        </Box>
      </Modal>
    </div>
  );
};

export default AddExternalChatModal;
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", sm: "80%", md: "60%", lg: "35%", xl: "35%" },
  bgcolor: "background.paper",
  borderRadius: 2,
  border: "2px solid #FFFFFF",
  p: 2,
  maxHeight: "80vh",
  overflowY: "auto",
};
